import React from 'react';
import PropTypes from 'prop-types';

import Typography from '../typography/typography';

import {
  FullScreenContainer,
  BannerGrid,
  HeadingArea,
  BackgroundImageArea,
  BackgroundImage,
} from './styles';

const Banner = ({ title, image }) => (
  <FullScreenContainer width={1920}>
    <BannerGrid>
      <HeadingArea>
        <Typography
          color="primary"
          variant="p"
          className="h1"
          css="font-weight: 300;"
        >
          {title}
        </Typography>
      </HeadingArea>

      <BackgroundImageArea>
        <BackgroundImage
          fluid={image.image}
          alt={image.alt}
          loading="eager"
          imgProps={{ fetchpriority: 'high' }}
        />
      </BackgroundImageArea>
    </BannerGrid>
  </FullScreenContainer>
);

Banner.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
};

export default Banner;
